module.exports = __webpack_public_path__ + "static/note-whoseinterface-dont-bc5a73ed47c692be4e561d0b2de9fff5.png";